/* @ngInject */
const myEmailInfo = (
  toaster,
  valueHandler,
  labels,
  $$email
) => {
  return {
    restrict: 'E',
    scope: {
      myEmails: '=',
      id: '@myId',
    },
    template: require('./myEmailInfo.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.removeEmail = async (_index) => {
        const id = $scope.myEmails[_index].id
        if (valueHandler.isId(id)) {
          try {
            const message = await $$email.request.delete(id)
            toaster.message(message)
            $scope.myEmails.splice(_index, 1)
          } catch (error) {
            toaster.error(error)
          }
        } else {
          toaster.message(labels.email.success.delete)
          $scope.myEmails.splice(_index, 1)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myEmailInfo



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/directives/myEmailInfo.js